export default __webpack_public_path__ + "static/media/second-place.d5d46509.svg";